import * as CommentingV3 from './CommentingV3';
export function getCommentingAPI() {
  return CommentingV3;
}